/**
 * SVG Zellige tile pattern — Moroccan geometric texture.
 * Eight-pointed star (khatam) with interlocking lines.
 * Renders as a fillable pattern with saffron + cedar tones.
 */
const ZelligePattern = ({
  id = "zellige-pattern",
  stroke = "#E8A045",
  strokeAlt = "#6B4F3A",
  opacity = 1,
  size = 80,
  strokeWidth = 0.7,
}) => {
  const half = size / 2;
  return (
    <defs>
      <pattern
        id={id}
        x="0"
        y="0"
        width={size}
        height={size}
        patternUnits="userSpaceOnUse"
      >
        {/* Background */}
        <rect width={size} height={size} fill="transparent" />

        {/* Eight-pointed star */}
        <g opacity={opacity}>
          <path
            d={`
              M ${half} ${size * 0.1}
              L ${size * 0.6} ${size * 0.32}
              L ${size * 0.88} ${half}
              L ${size * 0.6} ${size * 0.68}
              L ${half} ${size * 0.9}
              L ${size * 0.4} ${size * 0.68}
              L ${size * 0.12} ${half}
              L ${size * 0.4} ${size * 0.32}
              Z
            `}
            fill="none"
            stroke={stroke}
            strokeWidth={strokeWidth}
          />
          {/* inner diamond */}
          <path
            d={`
              M ${half} ${size * 0.25}
              L ${size * 0.75} ${half}
              L ${half} ${size * 0.75}
              L ${size * 0.25} ${half}
              Z
            `}
            fill="none"
            stroke={strokeAlt}
            strokeWidth={strokeWidth * 0.8}
            opacity="0.6"
          />
          {/* cross axes */}
          <line
            x1={half}
            y1="0"
            x2={half}
            y2={size}
            stroke={stroke}
            strokeWidth={strokeWidth * 0.5}
            opacity="0.35"
          />
          <line
            x1="0"
            y1={half}
            x2={size}
            y2={half}
            stroke={stroke}
            strokeWidth={strokeWidth * 0.5}
            opacity="0.35"
          />
          {/* corner crosses */}
          <line
            x1="0"
            y1="0"
            x2={size}
            y2={size}
            stroke={strokeAlt}
            strokeWidth={strokeWidth * 0.4}
            opacity="0.25"
          />
          <line
            x1={size}
            y1="0"
            x2="0"
            y2={size}
            stroke={strokeAlt}
            strokeWidth={strokeWidth * 0.4}
            opacity="0.25"
          />
        </g>
      </pattern>
    </defs>
  );
};

export const ZelligeFill = ({
  className = "",
  id = "zellige-fill",
  stroke = "#E8A045",
  strokeAlt = "#6B4F3A",
  size = 80,
  opacity = 0.5,
}) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <ZelligePattern
      id={id}
      stroke={stroke}
      strokeAlt={strokeAlt}
      size={size}
      opacity={opacity}
    />
    <rect width="100%" height="100%" fill={`url(#${id})`} />
  </svg>
);

export default ZelligePattern;
